<template>
  <div class="is-family-secondary">
    <b-navbar
      type="is-primary"
      fixed-top
      wrapper-class="container"
      close-on-click
    >
      <template slot="brand">
        <b-navbar-item tag="router-link" :to="{ path: '/' }">
          <img src="@/assets/images/logo@3x.png" alt="Mustard" />
        </b-navbar-item>
      </template>
      <!-- Start -->
      <template slot="start" v-if="auth.isAuthenticated">
        <!-- Home -->
        <router-link
          :to="{ name: 'home' }"
          class="navbar-item navbar-item-link is-uppercase"
        >
          Home
        </router-link>
        <!-- Student Hub -->
        <router-link
          :to="{ name: 'student-hub' }"
          class="navbar-item navbar-item-link is-uppercase"
        >
          Student Hub
        </router-link>
        <!-- Mustard Hub -->
        <b-navbar-item
          tag="div"
          class="has-dropdown is-hoverable navbar-item-link"
        >
          <a class="navbar-link is-uppercase is-block is-arrowless"
            >Mustard Hub</a
          >
          <div class="navbar-dropdown is-center">
            <router-link :to="{ name: 'news' }" class="navbar-item"
              >News & Updates</router-link
            >
            <router-link :to="{ name: 'resources' }" class="navbar-item"
              >Lunchtime Group Resources</router-link
            >
            <router-link :to="{ name: 'training' }" class="navbar-item"
              >Student Leaders Training</router-link
            >
          </div>
        </b-navbar-item>
        <!-- My Group -->
        <router-link
          :to="{ name: 'groups' }"
          class="navbar-item navbar-item-link is-uppercase"
          >My Group</router-link
        >
        <b-navbar-item
          v-if="auth.isAuthenticated"
          tag="div"
          class="navbar-is-mobile"
        >
          <hr />
          <router-link :to="{ name: 'edit-profile' }" class="navbar-item">
            Edit Profile
          </router-link>
          <a class="navbar-item" href="#" @click="userLogout">Logout</a>
        </b-navbar-item>
      </template>
      <!-- End -->
      <template slot="end">
        <b-navbar-item class="navbar-social" tag="div">
          <a
            rel="noreferrer"
            href="https://www.facebook.com/mustardschools/"
            target="_blank"
            class="i i-facebook"
            ><svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              viewBox="0 0 24 25"
            >
              <path
                fill="#FFF"
                fill-rule="evenodd"
                d="M24 12.944V6.871a6 6 0 0 0-6-6H6a6 6 0 0 0-6 6v12a6 6 0 0 0 6 6h4.125v-8.437H7.078v-3.49h3.047v-2.66c0-3.025 1.792-4.697 4.533-4.697 1.312 0 2.686.236 2.686.236v2.971H15.83c-1.491 0-1.956.93-1.956 1.886v2.264h3.328l-.532 3.49h-2.796v8.437H18a6 6 0 0 0 6-6v-5.927z"
              />
            </svg>
          </a>
          <a
            rel="noreferrer"
            href="https://www.instagram.com/mustardschools/"
            target="_blank"
            class="i i-instagram"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="19"
              viewBox="0 0 24 25"
            >
              <path
                fill="#FFF"
                fill-rule="evenodd"
                d="M17 .871a7 7 0 0 1 7 7v10a7 7 0 0 1-7 7H7a7 7 0 0 1-7-7v-10a7 7 0 0 1 7-7h10zm-4.002 3.201h-1.996c-1.504.003-1.842.016-2.63.052-.937.043-1.577.192-2.136.41a4.313 4.313 0 0 0-1.559 1.014c-.49.49-.79.98-1.015 1.559-.218.56-.366 1.2-.409 2.136-.043.938-.053 1.238-.053 3.628s.01 2.69.053 3.628c.043.937.191 1.577.409 2.136.225.58.526 1.07 1.015 1.56.49.488.98.79 1.559 1.014.56.218 1.2.366 2.136.41.938.042 1.238.052 3.628.052s2.69-.01 3.628-.053c.937-.043 1.577-.191 2.136-.409a4.314 4.314 0 0 0 1.559-1.015c.49-.49.79-.98 1.015-1.559.218-.56.366-1.199.409-2.136.043-.938.053-1.238.053-3.628s-.01-2.69-.053-3.628c-.043-.937-.191-1.576-.409-2.136a4.314 4.314 0 0 0-1.015-1.559c-.49-.49-.98-.79-1.559-1.015-.56-.217-1.2-.366-2.136-.409-.788-.036-1.126-.049-2.63-.052zm-.472 1.585c1.872.001 2.176.012 3.03.051.858.04 1.324.182 1.634.303.41.16.704.35 1.012.658.308.308.498.601.658 1.012.12.31.264.776.303 1.634.04.854.05 1.158.051 3.03v1.052c-.001 1.872-.012 2.176-.05 3.03-.04.858-.183 1.324-.304 1.634-.16.41-.35.704-.658 1.012a2.726 2.726 0 0 1-1.012.658c-.31.12-.776.264-1.634.303-.854.04-1.157.05-3.03.051h-1.052c-1.873-.001-2.176-.012-3.03-.05-.858-.04-1.324-.183-1.634-.304-.41-.16-.704-.35-1.012-.658a2.727 2.727 0 0 1-.658-1.012c-.12-.31-.264-.776-.303-1.634-.04-.854-.05-1.158-.051-3.03v-1.051c.001-1.873.012-2.177.05-3.03.04-.859.183-1.325.304-1.635.16-.41.35-.704.658-1.012a2.726 2.726 0 0 1 1.012-.658c.31-.12.776-.264 1.634-.303.854-.039 1.158-.05 3.03-.051h1.052zm-.82 3.107a4.4 4.4 0 1 0 0 8.8 4.4 4.4 0 0 0 0-8.8zm0 1.544a2.856 2.856 0 1 1 0 5.713 2.856 2.856 0 0 1 0-5.713zm4.987-3.304a1.173 1.173 0 1 0 0 2.347 1.173 1.173 0 0 0 0-2.347z"
              />
            </svg>
          </a>
          <span
            v-if="!auth.isAuthenticated"
            class="is-family-primary text-connect"
            >Connect with Mustard</span
          >
        </b-navbar-item>
        <b-navbar-item tag="div" v-if="!auth.isAuthenticated">
          <router-link
            class="button is-danger is-uppercase login tw-mr-8"
            :to="{ name: 'register' }"
            >Register</router-link
          >
          <router-link
            class="button is-danger is-uppercase login"
            :to="{ name: 'login' }"
            >Sign In</router-link
          >
        </b-navbar-item>
        <b-navbar-item
          v-if="auth.isAuthenticated"
          tag="div"
          class="navbar-avatar is-desktop-has-dropdown is-hoverable tw-flex tw-content-center tw-self-center"
        >
          <a class="navbar-item avatar">
            <span class="loading-avatar" v-if="isUpdating">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="#3333"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
                />
              </svg>
            </span>
            <img :src="avatar" />
          </a>
          <div class="navbar-dropdown is-right">
            <router-link :to="{ name: 'edit-profile' }" class="navbar-item">
              Edit Profile
            </router-link>
            <a class="navbar-item" href="#" @click="userLogout">Logout</a>
          </div>
        </b-navbar-item>
        <b-navbar-item
          v-if="auth.isAuthenticated"
          tag="div"
          class="tw-cursor-pointer notification-badge tw-my-auto"
          @click="gotoNotifications()"
        >
          <div
            :class="[
              {
                'tw-opacity-75 hover:tw-opacity-100': !notifications.unread
              }
            ]"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                d="M10 2a6 6 0 00-6 6v3.586l-.707.707A1 1 0 004 14h12a1 1 0 00.707-1.707L16 11.586V8a6 6 0 00-6-6zM10 18a3 3 0 01-3-3h6a3 3 0 01-3 3z"
              />
            </svg>
            <div
              v-if="notifications.unread"
              :class="[
                'count tw-self-end',
                { 'count-update': notifications.countUpdate }
              ]"
            >
              {{ notifications.unread }}
            </div>
          </div>
        </b-navbar-item>
        <b-navbar-item
          v-if="auth.isAuthenticated"
          tag="div"
          class="tw-cursor-pointer notification-badge tw-my-auto"
          @click="gotoMessages()"
        >
          <div
            :class="[
              {
                'tw-opacity-75 hover:tw-opacity-100': !notifications.unread
              }
            ]"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fill-rule="evenodd"
                d="M18 13V5a2 2 0 00-2-2H4a2 2 0 00-2 2v8a2 2 0 002 2h3l3 3 3-3h3a2 2 0 002-2zM5 7a1 1 0 011-1h8a1 1 0 110 2H6a1 1 0 01-1-1zm1 3a1 1 0 100 2h3a1 1 0 100-2H6z"
                clip-rule="evenodd"
              />
            </svg>
            <div
              v-if="notifications_msgs.unread"
              :class="[
                'count tw-self-end',
                { 'count-update': notifications_msgs.countUpdate }
              ]"
            >
              {{ notifications_msgs.unread }}
            </div>
          </div>
        </b-navbar-item>
      </template>
    </b-navbar>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters, mapMutations } from 'vuex'
import dayjs from 'dayjs'

export default {
  data() {
    return {
      event: '',
      avatar: '',
      isUpdating: false,
      externalUserId: null
    }
  },
  computed: {
    ...mapState({
      auth: state => state.auth,
      timestamp: state => state.auth.timestamp,
      notifications: state => state.notifications,
      notifications_msgs: state => state.notifications_msgs
    }),
    ...mapGetters({
      avatarThumb: 'auth/avatarThumb'
    })
  },
  methods: {
    ...mapActions({
      logout: 'auth/logout',
      getUnreadNotifications: 'getUnreadNotifications',
      getUnreadMessages: 'getUnreadMessages'
    }),
    ...mapMutations([
      'setCalendarTimezone',
      'setCalendarAction',
      'setCalendarUtcOffset'
    ]),

    setAvatar() {
      setTimeout(() => {
        this.avatar = this.auth.user.avatar_thumb_url + '?ts=' + this.timestamp
      }, 1000)
    },
    delay(ms) {
      return new Promise(resolve => setTimeout(resolve, ms))
    },
    userLogout() {
      window.OneSignal.push(() => {
        window.OneSignal.removeExternalUserId()
      })
      this.logout()
      if (this.$router.currentRoute.name !== 'home') {
        this.$router.push({ name: 'home' })
      }
    },
    gotoNotifications() {
      if (this.$router.currentRoute.name !== 'my-notifications') {
        this.$router.push({ name: 'my-notifications' })
      }
    },
    gotoMessages() {
      if (this.$router.currentRoute.name !== 'my-messages') {
        this.$router.push({ name: 'my-messages' })
      }
    },
    async setExternalUserId() {
      await window.OneSignal.push(() => {
        window.OneSignal.setExternalUserId(this.auth.user.id.toString())
      })
    },
    async getExternalUserId() {
      await window.OneSignal.push(() => {
        window.OneSignal.getExternalUserId().then(extUserId => {
          this.externalUserId = extUserId
          this.$store.commit('setNotificationExtId', extUserId)
        })
      })
    },
    async setNotificationInit() {
      if (!this.notifications.isInit) {
        await window.OneSignal.push(() => {
          window.OneSignal.init(this.$initOneSignal)
        })
        this.$store.commit('setNotificationInit', true)
      }
    }
  },
  watch: {
    timestamp: async function() {
      this.isUpdating = true
      await this.delay(7000)
      await this.setAvatar()
      await this.delay(1000)
      this.isUpdating = false
    },
    'auth.user': {
      deep: true,
      handler: async function(n, o) {
        if (n.id) {
          await this.delay(1000)
          this.setExternalUserId()
          await this.delay(1000)
          this.getExternalUserId()
          await this.delay(1000)
          this.setNotificationInit()
        }
      }
    },
    $route: function(to, from) {
      setTimeout(() => {
        if (this.auth.isAuthenticated) {
          this.setAvatar()
          this.getUnreadNotifications()
          this.getUnreadMessages()
        }
      }, 1000)
      this.setCalendarTimezone(dayjs.tz.guess())
      this.setCalendarUtcOffset(dayjs().utcOffset() / 60)
    }
  },
  mounted() {
    const menu = document.querySelector('.navbar-menu')
    const burger = document.querySelector('.burger')
    if (menu) {
      menu.querySelectorAll('.navbar-item').forEach(link => {
        link.addEventListener('click', function() {
          burger.classList.remove('is-active')
          menu.classList.remove('is-active')
        })
      })
    }

    if (this.auth.isAuthenticated) {
      this.setAvatar()
      this.getUnreadNotifications()
      this.getUnreadMessages()
    }

    window.OneSignal.push(() => {
      window.OneSignal.on('notificationDisplay', event => {
        this.event = event
        this.getUnreadNotifications()
        this.getUnreadMessages()
      })
    })
  },
  created() {
    if (this.auth.isAuthenticated && this.auth.user.id) {
      this.setNotificationInit()
    }
  }
}
</script>

<style lang="scss" scoped>
.login {
  min-width: 148px;
}
</style>
